import { axiosInstanceWithToken } from 'utils/axios';
import { IBulkDeleteRequest, IOrderPostRequest } from '../../server/types';

export const fetchOrders = async () => axiosInstanceWithToken().get('orders');

export const deleteOrder = async (id: string) => axiosInstanceWithToken().delete(`orders/${id}`);

export const createOrder = async (data: IOrderPostRequest) => axiosInstanceWithToken().post('orders', data);

export const downloadOrder = async (data: any) =>
  axiosInstanceWithToken().post('design-automation/download-order', data);

export const deleteOrders = async (data: IBulkDeleteRequest) => axiosInstanceWithToken().post(`orders/delete`, data);
